import React, {useEffect, useState} from 'react';
import {Link, useNavigate, useParams} from 'react-router-dom';
import Layout from '../components/Layout';
import {api} from '../../api';

export default function EditTimesheet() {
  const {id} = useParams();
  const navigate = useNavigate();
  const [employees, setEmployees] = useState([]);
  const [form, setForm] = useState(null);
  const [pendingCorrections, setPendingCorrections] = useState(0);

  useEffect(() => {
    Promise.all([
      api('/hcm/employees').then(r => r.ok ? r.json() : []),
      api(`/timesheets/timesheets/${id}`).then(r => r.ok ? r.json() : null),
    ]).then(([emps, ts]) => {
      setEmployees(emps);
      if (ts) setForm({employeeId: ts.employeeId, startDate: ts.startDate, endDate: ts.endDate, status: ts.status});
    });
    api(`/timesheets/time-corrections/pending-count?timesheetId=${id}`).then(r => r.ok ? r.json() : 0).then(setPendingCorrections);
  }, [id]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (form.status === 'APPROVED' && pendingCorrections > 0) return;
    api(`/timesheets/timesheets/${id}`, {method: 'PUT', body: JSON.stringify(form)})
      .then(() => navigate(`/timesheets/${id}`, {state: {saved: true}}));
  };

  const set = (field) => (e) => setForm(f => ({...f, [field]: e.target.value}));

  if (!form) return <Layout><div className="p-6">Loading...</div></Layout>;

  return (
    <Layout>
      <Link to={`/timesheets/${id}`} className="text-teal-600 hover:text-teal-800 mb-4 inline-block">&larr; Back</Link>
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Edit Timesheet</h2>
      <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow p-6 max-w-2xl space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Employee</label>
          <select required value={form.employeeId} onChange={set('employeeId')}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500">
            <option value="">Select employee...</option>
            {employees.map(e => <option key={e.id} value={e.id}>{e.firstName} {e.lastName}</option>)}
          </select>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Start Date</label>
            <input type="date" required value={form.startDate} onChange={set('startDate')}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">End Date</label>
            <input type="date" required value={form.endDate} onChange={set('endDate')}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500" />
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
          <select value={form.status} onChange={set('status')}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500">
            <option value="DRAFT">Draft</option>
            <option value="APPROVED" disabled={pendingCorrections > 0}>Approved</option>
          </select>
          {pendingCorrections > 0 && (
            <p className="mt-1 text-sm text-amber-600">Cannot approve — {pendingCorrections} pending time correction{pendingCorrections > 1 ? 's' : ''} must be resolved first.</p>
          )}
        </div>
        <div className="flex gap-3">
          <button type="submit" className="px-6 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700">Save</button>
          <Link to={`/timesheets/${id}`} className="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-50">Cancel</Link>
        </div>
      </form>
    </Layout>
  );
}
